//#region Util Imports

import * as _ from "underscore";
import * as $ from "jquery";
import * as moment from 'moment'

//#endregion

//#region DevExpress Imports

import DevExpress from "devextreme";
import dxDataGrid from "devextreme/ui/data_grid";
import { AsyncRule, CompareRule, CustomRule, EmailRule, NumericRule, PatternRule, RangeRule, RequiredRule, StringLengthRule } from "devextreme/ui/validation_engine";

//#endregion

import { Enums } from "../../../../../models/common";
import { ConvertHelper, LocalizationHelper } from "../../../../../helpers";
import { UserSessionService } from "../../../../../services/user-session";
import { IMRBaseControlController } from "../../../../../modules/common/base";

import { GridController, GridOptions, GridTypes } from "../../../../../modules/common/grid";
import { IIMRPopup, IMRPopupOptions } from "@imr/controls.angularjs/components/overlay/popup";
import { IMRComponentInitializedArgs } from "@imr/controls.angularjs/components/base";
import { OpReport } from "../../../../../models/dw";

import { StoredProcedureReportPopupForm, StoredProcedureReportPopupFormOptions } from "../stored-procedure-report.interfaces";
import { OpReportParam } from "../../../../../models/dw/op-report-param";
import { dxButtonOptions } from "devextreme/ui/button";
import { dxFormSimpleItem } from "devextreme/ui/form";
import { DropDownBoxOptions } from "../../../../../modules/common/drop-down-box/drop-down-box.interfaces";
import { IReferenceType } from "../../../../../models/util/interfaces";
import { OpDBScriptTable } from "../../../../../models/custom";
import dxValidationGroup, { dxValidationGroupOptions, dxValidationGroupResult } from "devextreme/ui/validation_group";

type DxFormItem = (DevExpress.ui.dxFormSimpleItem | DevExpress.ui.dxFormGroupItem | DevExpress.ui.dxFormTabbedItem | DevExpress.ui.dxFormEmptyItem | DevExpress.ui.dxFormButtonItem)
type DxValidationRule = (RequiredRule | NumericRule | RangeRule | StringLengthRule | CustomRule | CompareRule | PatternRule | EmailRule | AsyncRule)


export class StoredProcedureReportPopupFormController
    extends IMRBaseControlController<
        StoredProcedureReportPopupForm,
        StoredProcedureReportPopupFormOptions
    >
    implements StoredProcedureReportPopupForm {
    private report: OpReport
    private formOptions: DevExpress.ui.dxFormOptions;
    private form: DevExpress.ui.dxForm;
    private formData: any

    private gridOptions: GridOptions
    private grid: GridController<any>
    private dataGrid: dxDataGrid

    private imrPopupOptions: IMRPopupOptions
    private imrPopup: IIMRPopup


    private submitButtonOptions: dxButtonOptions
    private submitButton: DevExpress.ui.dxButton
    private exportButtonOptions: dxButtonOptions
    private exportButton: DevExpress.ui.dxButton

    private dropDownOptions: { [key: number]: DropDownBoxOptions } = {}

    private validationGroupOptions: dxValidationGroupOptions
    private validationGroup: dxValidationGroup

    constructor(
        private userSession: UserSessionService,
    ) {
        super();
    }

    //#region Component

    protected initialize(options: StoredProcedureReportPopupFormOptions) {
        this.setOptions();
    }

    //#endregion

    private setOptions(): void {
        this.setImrPopupOption()
        this.setFormOptions()
        this.setGridOptions()
        this.setSubmitButtonOptions()
        this.setExportButtonOptions()
    }


    private setImrPopupOption() {
        this.imrPopupOptions = {
            innerOptions: {
                fullScreen: true,
                onHiding: (e: any): void => {
                    this.grid.setDataSource([])
                }
            },
            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.imrPopup = e.component
            },
            // bottomToolbarOptions: {
            //     items: [{
            //         location: 'after',
            //         widget: 'dxButton',
            //         options: <DevExpress.ui.dxButtonOptions>{
            //             text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
            //             hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
            //             disabled: true,
            //             onInitialized: (e: any) => {
            //                 this.submitButton = e.component
            //             },
            //             onClick: (e: any) => {
            //                 this.onSubmitForm()
            //             }
            //         },

            //     }, {
            //         location: 'after',
            //         widget: 'dxButton',
            //         options: <DevExpress.ui.dxButtonOptions>{
            //             text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
            //             hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
            //             onClick: (e: any) => {
            //                 if (this.imrPopup != null) {
            //                     this.imrPopup.hide()
            //                 }
            //             }
            //         }
            //     }]
            // }
        }
    }

    private onSubmitForm(): void {
        const validateForm: dxValidationGroupResult = this.form.validate()
        const validateGroup: dxValidationGroupResult = this.validationGroup.validate()

        if (validateForm.isValid == true && validateGroup.isValid == true) {
            this.imrPopup.showLoading()

            _.forEach(this.report.paramsList, (param: OpReportParam) => {
                if (param.isInputParam == true) {
                    const formValue: any = this.formData[param.idReportParam]

                    if (param.idReferenceType != null) {
                        if (this.dropDownOptions[param.idReportParam] != null && this.dropDownOptions[param.idReportParam].multiSelectEnabled == true) {
                            if (_.size(formValue) === 0) {
                                param.value = null
                            } else {
                                param.value = formValue.join(';')
                            }
                        } else {
                            param.value = _.first(formValue)

                            if (param.idDataTypeClass === Enums.DataTypeClass.Text) {
                                if (param.value != null) {
                                    param.value = param.value.toString()
                                }
                            } else {
                                param.value = param.value
                            }
                        }
                    } else if (this.isDateOrTime(param.idDataTypeClass)) {
                        param.value = moment(formValue).format('YYYY-MM-DD HH:mm:ss.SSS')
                    } else {
                        param.value = formValue
                    }
                }
            })

            this.userSession
                .getDataProvider()
                .Report
                .generateReport(this.report)
                .then((response: any) => {
                    const responseData: OpDBScriptTable = new OpDBScriptTable(response)

                    this.prepareGridDataSource(responseData)
                })
                .always(() => {
                    this.imrPopup.hideLoading()
                })
        }
    }

    private prepareGridDataSource(responseData: OpDBScriptTable): void {
        const dataSource: { [key: string]: any }[] = []

        if (responseData != null) {
            _.forEach(responseData.rows, (row: any[]) => {
                const data: { [key: string]: any } = {}

                _.forEach(responseData.headers, (header: string, index: number) => {
                    if (_.size(row) > index) {

                        const param: OpReportParam = _.find(this.report.paramsList, (p: OpReportParam) => {
                            return p.fieldName == header
                        })

                        if (param != null) {
                            if (this.isDateOrTime(param.idDataTypeClass)) {
                                data[header] = ConvertHelper.dateToString(ConvertHelper.stringToDate(row[index]))
                            } else {
                                data[header] = row[index]
                            }
                        } else {
                            data[header] = row[index]
                        }
                    }
                })

                dataSource.push(data)
            })
        }

        this.grid.setDataSource(dataSource)
    }

    private setFormOptions(): void {
        this.formOptions = {
            colCount: 3,
            bindingOptions: {
                formData: '$ctrl.formData'
            },
            height: '100%',
            scrollingEnabled: true,
            validationGroup: 'validationGroup',
            onInitialized: (e: any): void => {
                this.form = e.component
            },
        }

        this.validationGroupOptions = {
            onInitialized: (e: any) => {
                this.validationGroup = e.component
            },
        }
    }

    private getFormItems(report: OpReport): DxFormItem[] {
        const paramItems: OpReportParam[] = _.filter(report.paramsList, (param: OpReportParam) => { return param.isInputParam })

        const getEditorType = (id: Enums.DataTypeClass): 'dxAutocomplete' | 'dxCalendar' | 'dxCheckBox' | 'dxColorBox' | 'dxDateBox' | 'dxDropDownBox' | 'dxHtmlEditor' | 'dxLookup' | 'dxNumberBox' | 'dxRadioGroup' | 'dxRangeSlider' | 'dxSelectBox' | 'dxSlider' | 'dxSwitch' | 'dxTagBox' | 'dxTextArea' | 'dxTextBox' => {
            switch (id) {
                case Enums.DataTypeClass.Boolean:
                    return 'dxCheckBox'
                case Enums.DataTypeClass.Date:
                case Enums.DataTypeClass.Time:
                case Enums.DataTypeClass.Datetime:
                    return 'dxDateBox'
                default:
                    return 'dxTextBox'
            }
        }

        const formItems = _.map(paramItems, (param: OpReportParam) => {
            const isMultySelection: boolean = param.idReferenceType == null ? false : _.contains([Enums.ReferenceType.OperatorList, Enums.ReferenceType.TaskStatusList, Enums.ReferenceType.LocationList, Enums.ReferenceType.DistributorList, Enums.ReferenceType.MeterTypeList, Enums.ReferenceType.DeviceTypeList, Enums.ReferenceType.AreaList], param.idReferenceType)

            const item: dxFormSimpleItem = {
                dataField: param.idReportParam.toString(),
                label: {
                    text: param.name
                },
                isRequired: !isMultySelection,
                editorType: getEditorType(param.idDataTypeClass)
            }

            if (param.idReferenceType > 0) {
                if (this.dropDownOptions == null) {
                    this.dropDownOptions = {}
                }

                this.dropDownOptions[param.idReportParam] = {
                    referenceType: param.idReferenceType,
                    multiSelectEnabled: isMultySelection,
                    ignoreHierarhcy: true,
                    validationRulles: isMultySelection ? [] : [{
                        message: LocalizationHelper.getLocalizedText(
                            LocalizationHelper.Text.RequiredField
                        ),
                        type: 'custom',
                        validationCallback: (e: any) => {
                            return _.size(e.value) > 0
                        }
                    }],
                    onValueChanged: (ids, objects) => {
                        this.onDropDownValueChanged(param.idReportParam.toString(), ids, objects)
                    },
                }
                item.template = '<drop-down-box options="$ctrl.dropDownOptions[' + param.idReportParam + ']"/>'
            }

            return item
        })

        return formItems
    }

    private setGridOptions(): void {
        this.gridOptions = {
            buttonsOptions: { enabled: false },
            columns: [],
            dataSource: [],
            name: '',
            type: GridTypes.PAGINATED_SMALL,
            onInitialized: (e: any, grid: GridController<any>) => { this.onGridInitialized(e, grid) }

        }
    }

    private updateGridColumns(report: OpReport): void {
        const getColumnType = (id: Enums.DataTypeClass): string => {
            switch (id) {
                case Enums.DataTypeClass.Real:
                case Enums.DataTypeClass.Decimal:
                case Enums.DataTypeClass.Integer:
                    return 'number'
                case Enums.DataTypeClass.Boolean:
                    return 'boolean'
                default:
                    return 'string'
            }
        }

        const columns: DevExpress.ui.dxDataGridColumn[] = _.map(_.filter(report.paramsList, (parameter: OpReportParam) => { return parameter.isInputParam === false }), (param: OpReportParam) => {
            return <DevExpress.ui.dxDataGridColumn>{
                caption: param.name,
                dataField: param.fieldName,
                dataType: getColumnType(param.idDataTypeClass),
                visible: param.isVisible
            }
        })

        if (this.dataGrid != null) {
            this.dataGrid.option('columns', columns)
            this.dataGrid.option('export.fileName', report.toString())
        }
    }

    private updateForm(report: OpReport): void {
        if (this.form != null) {
            this.form.option('items', this.getFormItems(report))

            if (this.report != null) {
                this.formData = {}
                _.forEach(this.report.paramsList, (param: OpReportParam) => {
                    if (param.isInputParam) {
                        if (param.value == null) {
                            this.formData[param.idReportParam] = null
                        } else if (this.isDateOrTime(param.idDataTypeClass)) {
                            this.formData[param.idReportParam] = ConvertHelper.stringToDate(param.value)
                        } else {
                            this.formData[param.idReportParam] = param.value
                        }
                    }
                })
            }
        }
    }

    private isDateOrTime(value: Enums.DataTypeClass): boolean {
        return value === Enums.DataTypeClass.Date || value === Enums.DataTypeClass.Time || value === Enums.DataTypeClass.Datetime
    }

    private getReport(idReport: number) {
        this.imrPopup.showLoading()
        this.userSession
            .getDataProvider()
            .Report
            .getReport(idReport)
            .then((report: OpReport) => {
                this.report = report

                setTimeout(() => {
                    this.imrPopup.getInnerPopup().option('title', report.toString())
                }, 500)

                this.updateGridColumns(report)
                this.updateForm(report)
            })
            .always(() => {
                this.imrPopup.hideLoading()
            })
    }

    private onGridInitialized(e: any, grid: GridController<any>) {
        this.grid = grid
        this.dataGrid = e.component;
    }

    private setSubmitButtonOptions(): void {
        this.submitButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.GenerateReport),
            height: 50,
            validationGroup: 'validationGroup',
            onInitialized: (e: any) => {
                this.submitButton = e.componet
            },
            onClick: (e: any) => {
                this.onSubmitForm()
            }
        }
    }

    private setExportButtonOptions(): void {
        this.exportButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Export),
            height: 50,
            onInitialized: (e: any) => {
                this.exportButton = e.componet
            },
            onClick: (e: any) => {
                if (this.grid != null) {
                    this.grid.dxGrid.exportToExcel(false)
                }
            }
        }
    }

    private onDropDownValueChanged(idReportParam: string, ids: number[], objects: IReferenceType[]) {
        this.formData[idReportParam] = ids
    }
    //#region IIMRInstallationCategoryPopup

    public showPopup(idReport: number): void {
        this.report = null
        this.formData = {}

        if (this.imrPopup != null) {
            this.imrPopup.show()
            this.getReport(idReport)
        }
    }

    public hidePopup(): void {
        if (this.imrPopup != null) {
            this.imrPopup.hide();
        }
    }

    //#endregion
}
